//* Libraries imports
import React from "react";
import { Container } from "@mui/material";

//* Components Imports
import ScrollTransition from "components/ScrollTransition";

//* Styles Imports
import styles from "./styles.module.css";

//* Icons Imports
import HandshakeIcon from "@mui/icons-material/Handshake";
import BoltIcon from "@mui/icons-material/Bolt";
import SmartphoneIcon from "@mui/icons-material/Smartphone";

function WhySection() {
  return (
    <section
      id="why-section"
      data-testid="why-section"
      aria-label="Seção de justificativas e benefícios para cadastrar a loja"
      className={styles.whySection}
    >
      <Container
        id="why-container"
        data-testid="why-container"
        aria-label="Container dos cartões de benefícios"
        maxWidth="xl"
      >
        <ScrollTransition
          id="why-title-transition"
          data-testid="why-title-transition"
          aria-label="Animação de entrada do título dos benefícios"
        >
          <h2
            id="why-title"
            data-testid="why-title"
            aria-label="Título: Por que se cadastrar?"
            className={styles.sectionTitle}
          >
            <span className={styles.highlight}>Por que se</span> cadastrar ?
          </h2>
          <div
            id="why-divider"
            data-testid="why-divider"
            aria-label="Linha decorativa amarela"
            className={styles.divider}
          />
        </ScrollTransition>

        <div
          id="why-cards-grid"
          data-testid="why-cards-grid"
          aria-label="Grade de benefícios com três colunas"
          className={styles.cardsGrid}
        >
          <ScrollTransition
            id="card-vende-recebe-transition"
            data-testid="card-vende-recebe-transition"
            aria-label="Animação do cartão vende e recebe"
            delay={200}
          >
            <div
              id="card-vende-recebe"
              data-testid="card-vende-recebe"
              aria-label="Benefício: Vende e Recebe"
              className={styles.card}
            >
              <div
                id="icon-vende-recebe-container"
                data-testid="icon-vende-recebe-container"
                aria-label="Contêiner do ícone vende e recebe"
                className={styles.iconContainer}
              >
                <HandshakeIcon
                  id="icon-vende-recebe"
                  data-testid="icon-vende-recebe"
                  aria-label="Ícone de aperto de mão"
                  sx={{ fontSize: "2.5rem" }}
                />
              </div>
              <h3
                id="title-vende-recebe"
                data-testid="title-vende-recebe"
                aria-label="Título do benefício: Vende e Recebe"
                className={styles.cardTitle}
              >
                <span className={styles.highlight}>Vende e Recebe</span>
              </h3>
              <p
                id="text-vende-recebe"
                data-testid="text-vende-recebe"
                aria-label="Descrição do benefício vende e recebe"
                className={styles.cardText}
              >
                O iGooB faz todo o processo de venda e cobrança por você.
              </p>
            </div>
          </ScrollTransition>

          <ScrollTransition
            id="card-velocidade-total-transition"
            data-testid="card-velocidade-total-transition"
            aria-label="Animação do cartão velocidade total"
            delay={400}
          >
            <div
              id="card-velocidade-total"
              data-testid="card-velocidade-total"
              aria-label="Benefício: Velocidade Total"
              className={styles.card}
            >
              <div
                id="icon-velocidade-total-container"
                data-testid="icon-velocidade-total-container"
                aria-label="Contêiner do ícone velocidade total"
                className={styles.iconContainer}
              >
                <BoltIcon
                  id="icon-velocidade-total"
                  data-testid="icon-velocidade-total"
                  aria-label="Ícone de raio"
                  sx={{ fontSize: "2.5rem" }}
                />
              </div>
              <h3
                id="title-velocidade-total"
                data-testid="title-velocidade-total"
                aria-label="Título do benefício: Velocidade Total"
                className={styles.cardTitle}
              >
                <span className={styles.highlight}>Velocidade Total</span>
              </h3>
              <p
                id="text-velocidade-total"
                data-testid="text-velocidade-total"
                aria-label="Descrição do benefício velocidade total"
                className={styles.cardText}
              >
                Muito mais rápido que processos manuais lentos.
              </p>
            </div>
          </ScrollTransition>

          <ScrollTransition
            id="card-pedido-pronto-transition"
            data-testid="card-pedido-pronto-transition"
            aria-label="Animação do cartão pedido pronto"
            delay={600}
          >
            <div
              id="card-pedido-pronto"
              data-testid="card-pedido-pronto"
              aria-label="Benefício: Pedido Pronto"
              className={styles.card}
            >
              <div
                id="icon-pedido-pronto-container"
                data-testid="icon-pedido-pronto-container"
                aria-label="Contêiner do ícone pedido pronto"
                className={styles.iconContainer}
              >
                <SmartphoneIcon
                  id="icon-pedido-pronto"
                  data-testid="icon-pedido-pronto"
                  aria-label="Ícone de smartphone"
                  sx={{ fontSize: "2.5rem" }}
                />
              </div>
              <h3
                id="title-pedido-pronto"
                data-testid="title-pedido-pronto"
                aria-label="Título do benefício: Pedido Pronto"
                className={styles.cardTitle}
              >
                <span className={styles.highlight}>Pedido Pronto</span>
              </h3>
              <p
                id="text-pedido-pronto"
                data-testid="text-pedido-pronto"
                aria-label="Descrição do benefício pedido pronto"
                className={styles.cardText}
              >
                Sua loja recebe o pedido apenas para separar e entregar.
              </p>
            </div>
          </ScrollTransition>
        </div>
      </Container>
    </section>
  );
}

export default WhySection;
